import {
  provideHttpClient,
  withInterceptorsFromDi
} from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Icons } from './constants/icons.const';

@NgModule({
  imports: [],
  providers: [MatIconRegistry, provideHttpClient(withInterceptorsFromDi())]
})
export class IconModule {
  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {
    this.matIconRegistry
      .addSvgIcon(
        'telus-calendar',
        this.setPath('assets/icons/telus/calendar.svg')
      )
      .addSvgIcon(
        'telus-stock-supply',
        this.setPath('assets/icons/telus/stock-supply.svg')
      )
      .addSvgIcon('telus-field', this.setPath('assets/icons/telus/field.svg'))
      .addSvgIcon(
        'telus-intercom',
        this.setPath('assets/icons/telus/intercom.svg')
      )
      .addSvgIcon(
        'nutrient-management',
        this.setPath('assets/icons/dark/nutrient-mgmt.svg')
      )
      .addSvgIcon(
        Icons.CropRequirements,
        this.setPath(`assets/icons/nutrient-plan/${Icons.CropRequirements}.svg`)
      )
      .addSvgIcon(
        Icons.LivestockLoading,
        this.setPath(`assets/icons/nutrient-plan/${Icons.LivestockLoading}.svg`)
      )
      .addSvgIcon(
        Icons.SlurryStorage,
        this.setPath(`assets/icons/nutrient-plan/${Icons.SlurryStorage}.svg`)
      )
      .addSvgIcon(
        'telus-cultivate',
        this.setPath('assets/icons/telus/cultivate.svg')
      );
  }

  private setPath(url: string): SafeResourceUrl {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
